module.exports = __webpack_public_path__ + "img/Profile-13.1d57a9e5.png";